<template lang="pug">
  #appFooter.appFooter.appFooter-sa
</template>

<script>
export default {
  name: 'appSaFooter'
};
</script>

<style>

</style>
